import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { bannerSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const next = useCallback(() => setIndex((i) => (i + 1) % bannerSlides.length), []);
  const prev = () => setIndex((i) => (i - 1 + bannerSlides.length) % bannerSlides.length);

  useEffect(() => {
    const timer = window.setInterval(next, 6000);
    return () => window.clearInterval(timer);
  }, [next]);

  const slide = bannerSlides[index];

  return (
    <section className="relative h-[480px] w-full overflow-hidden bg-primary-950 md:h-[620px]">
      {bannerSlides.map((s, i) => (
        <div
          key={s.title}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={s.image}
            alt={`${s.title} - 美味的快递`}
            title={`${s.title} - 美味的快递`}
            className="h-full w-full object-cover"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />

      <div className="relative z-10 flex h-full w-full items-center">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
          <div key={index} className="max-w-2xl animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-4 py-1.5 text-xs font-bold text-background-50">
              <i className="ri-sparkling-2-line" />
              {slide.eyebrow}
            </span>
            <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight text-white md:text-5xl">
              {slide.title}
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">{slide.desc}</p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to={slide.primaryTo}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition hover:bg-primary-600"
              >
                <i className="ri-shopping-bag-3-line text-base" />
                {slide.primaryLabel}
              </Link>
              <Link
                to={slide.secondaryTo}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/60 bg-white/10 px-7 py-3.5 text-sm font-bold text-white backdrop-blur transition hover:bg-white/20"
              >
                {slide.secondaryLabel}
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={prev}
        className="absolute left-3 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/40 bg-black/25 text-white backdrop-blur transition hover:bg-black/45 md:left-6 md:flex"
      >
        <i className="ri-arrow-left-s-line text-xl" />
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={next}
        className="absolute right-3 top-1/2 z-20 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/40 bg-black/25 text-white backdrop-blur transition hover:bg-black/45 md:right-6 md:flex"
      >
        <i className="ri-arrow-right-s-line text-xl" />
      </button>

      <div className="absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 gap-2">
        {bannerSlides.map((s, i) => (
          <button
            key={s.title}
            type="button"
            aria-label={`切换到第 ${i + 1} 张`}
            onClick={() => setIndex(i)}
            className={`h-2 rounded-full transition-all ${i === index ? "w-8 bg-primary-400" : "w-2 bg-white/60"}`}
          />
        ))}
      </div>
    </section>
  );
}